import styled from '@emotion/styled';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import type { Immutable } from 'immer';
import type { FC } from 'react';
import { Button } from 'react-bootstrap';
import { IconMap } from '../../Icon';

interface Props {
  event: Immutable<RacemapEvent>;
}

export const PlayerLinkButton: FC<Props> = ({ event }) => {
  const eventSlug = event.slug !== '' ? event.slug : event.id;
  return (
    <ButtonStyled
      href={`/player/${eventSlug}`}
      target="_blank"
      size="sm"
      variant="outline-secondary"
    >
      <Icon />
    </ButtonStyled>
  );
};

const ButtonStyled = styled(Button)`
  border-radius: 5px;
  margin-left: 5px;
  border-color: #ced4da;

  :hover {
    img {
      filter: brightness(500) grayscale(10);
    }
  }
`;

const Icon = styled(IconMap)`
  filter: brightness(0.8) grayscale(10);
`;
